<template>
  <div class="overlayLoader">
    <v-overlay :value="overlay" style="z-index:9999;"
      color="#FFB5CC"
      opacity="1"
    >
      <h1 class="logoIcon"><img src="@/assets/logo_white.svg" alt="we done"></h1>
      <p class="logoLine"></p>
      <p class="logoTitle">We Done!</p>
      <v-progress-circular
        style="margin: auto; display: block"
        indeterminate
        color="#fff"
      ></v-progress-circular>
      <!-- <p class="mt-10" v-if="text">{{ text }}</p> -->
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "OverlayLoader",
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: undefined,
    },
  },
};
</script>
<style lang="scss">
.overlayLoader{
  text-align: center;  
}
.logoIcon{
  margin-bottom: 20px;
}
.logoLine{
  width: 20px;
  margin: 0 auto 8px;
  border-bottom: 2px solid #fff;
}
.logoTitle{
  letter-spacing: 0;
  margin-bottom: 0;
  color: #fff;
}
</style>